export const BODY_CELL_STATUS_OPTION_SUCCESS = 'success';
export const BODY_CELL_STATUS_OPTION_ERROR = 'error';
export const BODY_CELL_STATUS_OPTION_WARNING = 'warning';
export const BODY_CELL_STATUS_OPTION_PRIMARY = 'primary';
export const BODY_CELL_STATUS_OPTION_UNKNOWN = 'unknown';

export const COLOR_SUCCESS = 'success';
export const COLOR_INFO = 'info';
export const COLOR_WARNING = 'warning';
export const COLOR_ERROR = 'error';
